import React from 'react';
import { object, string } from 'prop-types';
import { sanitizeHtml } from '@airasia-common/libraries/sanitizer';
import Wrapper from '../Wrapper';

const RawHTML = ({ children, style }) => (
  <Wrapper
    dangerouslySetInnerHTML={{ __html: sanitizeHtml(children) }}
    style={style}
  />
);

RawHTML.propTypes = { children: string, style: object };
RawHTML.defaultProps = { children: '' };

export default RawHTML;
